<template>
    <AuthenticatedLayout>
        <Toast position="top-center" />

        <div class="text-4xl mr-4 my-4 ">Grid bots <span class="text-green-500 pl-4">${{profitToday}}</span> <span class="text-base text-gray-800">за сегодня</span></div>
        <Card>
            <template #content>
                <PairsTwoTableSelector :items="botPairMenuItems" :compact="false" :select="handleSelectPair">
                </PairsTwoTableSelector>
            </template>
        </Card>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import helperMethods from '@/helpers';
import Card from "primevue/card";
import InputSwitch from "primevue/inputswitch";
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";

export default {
    components:{
        PairsTwoTableSelector,
        AuthenticatedLayout, Toast, DataTable, Column, ColumnGroup, Row, Card, InputSwitch
    },
    props:{
        botPairMenuItems: Array,
        profitToday: Number,
    },
    data(){
        return {
            selectedPair: null,
        }
    },
    methods:{
        ...helperMethods,
        handleSelectPair(botPairMenuData){
            this.$inertia.visit(`/grid/${botPairMenuData.pair_id}`)
        },
    }


}
</script>
